import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';
import {UserService} from '../../../services/user.service';
import {Globals} from '../../../globals';
import {LocalStorageService} from '../../../services/local-storage.service';
import {TaskService} from '../../../services/task.service';
import {SystemTaskDataModel} from '../../../models/messaging/system-task-data.model';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { ViewChild } from '@angular/core';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {StaticDataService} from '../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {TdoTableRowModel} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {TaskDetailDialogComponent} from '../task-detail-dialog/task-detail-dialog.component';
import {TdoUserGroupConfigurationModel} from '../../../models/configuration/user/tdo-user-group-configuration.model';
import {ConversionUtilities} from '../../../utilities/conversion.utilities';
// import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';


export class TaskManagementDetailDialogModel {
  model: SystemTaskDataModel;
  userGroups: TdoUserGroupConfigurationModel[];
  users: TdoUserConfigurationModel[];

  isAssignToUserDialog: boolean = false;
}

export class TaskQueryModel {
  isShowAllUserTasks: boolean   = false;
  isShowCompletedTasks: boolean = false;
  isShowSystemTasks: boolean    = false;
  isShowCancelled: boolean      = false;

  startDate: Date;

  endDate: Date;
  userId: string;

}

@Component({
  selector: 'app-task-management-dialog',
  templateUrl: './task-management-dialog.component.html',
  styleUrls: ['./task-management-dialog.component.scss']
})
export class TaskManagementDialogComponent implements OnInit {
  @ViewChild('taskTable') taskTable: TdoTableV2Component;

  users: TdoUserConfigurationModel[] = [];
  currentUser: TdoUserConfigurationModel;
  tasks: SystemTaskDataModel[];

  isLoading : boolean = true;

  filterStartDate: Date = new Date(Date.now());
  filterEndDate: Date;

  isAllTasks: boolean = false;
  isShowCompletedTasks: boolean = false;
  isShowSystemTasks: boolean = false;

  userTaskTypeEnums: EnumValidValueItemModel[] = [];
  systemTaskTypeEnums: EnumValidValueItemModel[] = [];
  taskStatusEnums: EnumValidValueItemModel[] = [];
  taskPriorityEnums: EnumValidValueItemModel[] = [];

  userGroups: TdoUserGroupConfigurationModel[] = [];

  TZID: string = '';

  queryModel: TaskQueryModel = new TaskQueryModel();

  constructor(private dialogRef: MatDialogRef<TaskManagementDialogComponent>,
              private dialog: MatDialog,
              private globals: Globals,
              private taskService: TaskService,
              private staticDataService: StaticDataService,
              private localStorageService: LocalStorageService,
              private userService: UserService,
              private snackBar: MatSnackBar,) { }

  ngOnInit(): void {
    this.TZID = this.localStorageService.currentUserData.authdata.tzId;
this.localStorageService=new LocalStorageService();
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    } else {
      this.setupEnums();
    }

    this.userService.getUsers(this.globals.TDOCID).subscribe((users) => {
      this.users = users;

      this.userService.getUserGroups(parseInt(this.globals.TDOCID)).subscribe((groupsRes) => {
        this.userGroups = groupsRes;
      });
      this.currentUser = this.users.find(p => p.UserID === this.localStorageService.currentUserData.authdata.userid);
      this.queryModel.userId = this.currentUser.UserID;
      //this.taskService.getUser(this.localStorageService.currentUserData.authdata.userid).subscribe((user) => {
      //  console.log("task oninit", user);
      //  //this.currentUser = user;
        this.getTasks();
      //});
    });
  }

  setupEnums() {
    this.userTaskTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumUserTaskType');
    this.systemTaskTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumSystemTaskType');
    this.taskStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumTaskStatus');
    this.taskPriorityEnums = this.staticDataService.getValidValueItemsByValidValueName('enumTaskPriority');
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close();
  }

  getUserFullName() {
    if (this.currentUser) {
      return this.currentUser.FirstName + ' ' + this.currentUser.LastName;
    }
    else {
      return '';
    }
  }

  onStartDateChange(event: MatDatepickerInputEvent<any, any>) {
    // event.value = data
  }

  onEndDateChange(event: MatDatepickerInputEvent<any, any>) {

  }

  onAddNewTask() {
    if (!this.tasks) {
      this.tasks = [];
    }

    let task = new SystemTaskDataModel();
    task.DueDate = new Date(Date.now());
    task.enumUserTaskTypeID = '00000850-1000-0000-0000-000000000007';
    task.ObjectId = null;
    task.enumObjectTypeID = null;
    task.isSystem = false;
    task.enumSystemTaskID = null;
    task.LOCID = parseInt(this.globals.LOCID);
    task.AssignedToUserID = this.currentUser.UserID;
    task.enumTaskStatusID = '00000051-1000-0000-0000-000000000001';
    task.enumTaskPriorityID = '00000052-1000-0000-0000-000000000003';
    task.Description = 'Please describe this task';

    this.taskService.saveTask(task).subscribe((taskRes) => {
      task = taskRes;
      this.tasks.unshift(task);
      this.taskTable.updateData(); 
    });
  }

  getUserTaskType(enumId: string) {
    if (this.userTaskTypeEnums) {
      const type = this.userTaskTypeEnums.find(p => p.ValidValueItemId === enumId);
      if (type) {
        return type.ItemDisplayValue;
      }
    }
    return '';
  }

  getUserAssigned(AssignedToUserID: string) {
    if (this.users) {
      const user = this.users.find(p => p.UserID === AssignedToUserID);
      if (user) {
        return user;
      }
    }
    return null;
  }

  onAssignedUserChange(event: any, row: TdoTableRowModel) {
    row.model.AssignedToUserID = event.value.UserID;
    this.saveTask(row.model);
  }

  saveTask(model: SystemTaskDataModel) {
    this.taskService.saveTask(model).subscribe((res) => {
      this.taskService.getTasks(this.queryModel).subscribe((tasksRes) => {
        this.tasks = tasksRes;
        setTimeout(() => {
          this.taskTable.updateData();
        }, 100);
      });     
    });
  }

  getPriority(enumTaskPriorityID: string) {
    if (this.taskPriorityEnums) {
      const priority = this.taskPriorityEnums.find(p => p.ValidValueItemId === enumTaskPriorityID);
      if (priority) {
        return priority.ItemDisplayValue;
      }
    }
    return '';
  }

  getTaskStatus(enumTaskStatusID: string) {
    if (this.taskStatusEnums) {
      const status = this.taskStatusEnums.find(p => p.ValidValueItemId === enumTaskStatusID);
      if (status) {
        return status;
      }
    }
    return null;
  }

  onTaskStatusChange(event: any, row: TdoTableRowModel) {
    row.model.enumTaskStatusID = event.value.ValidValueItemId;
    this.saveTask(row.model);
  }

  getDate(date: string) {
    const date1 = new Date(date);
    return date1.toLocaleString();
  }

  openTaskDetails(model: SystemTaskDataModel) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.width ="auto";
    config.height= "auto";
    const mod = new TaskManagementDetailDialogModel();
    mod.model = model;
    mod.users = this.users;
    mod.userGroups = this.userGroups;
    config.data = mod;
    this.dialog.open(TaskDetailDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        // Update model in list
      }
    });
  }

  getTasks() {
    this.isLoading=true;
    this.taskService.getTasks(this.queryModel).subscribe((res) => {
      this.tasks = res;
      setTimeout(() => {
        this.taskTable.updateData();
        this.isLoading=false;  
      }, 100);
    });
  }

  hideLoader() {
    this.isLoading=false;

  }


  onShowTasksChange(event: any) {
    this.queryModel.isShowAllUserTasks = event;

    this.validateFilter();


    if(!this.queryModel.isShowAllUserTasks)
    {
        this.queryModel.startDate=undefined;
        this.queryModel.endDate=undefined;
    }

    // this.getTasks();
  }

   validateFilter(): boolean  {
    var ret : boolean = false;

    if(this.queryModel.isShowAllUserTasks)
    {
      if(!this.queryModel.startDate)
      {
          this.snackBar.open("Please select a start date!", "More Info Needed")
          return ret;
      }

      var td = new Date();

      if(td > this.queryModel.startDate)
      {
        var d = td.valueOf() - this.queryModel.startDate.valueOf();

        if(d > 1000*60*60*24 *  30 )
        {
          this.snackBar.open("Please select a valid start date (30 days or less)!", "More Info Needed")
          return ret;
        }
      }
      else
      {
        this.snackBar.open("Please select a an start date grater than Today: "+ td.toDateString(), "Better Info Needed")
        return ret;
      }
    }
    else
    {
      // do nothing 
    }
    ret = true;
    return ret;
  }


  onReload()  {

    if(this.validateFilter()) {
      this.getTasks();
    }
  }

  getFor(model: SystemTaskDataModel) {
    if (model.ForUserID) {
      const user = this.users.find(p => p.UserID === model.ForUserID);
      if (user) {
        return user.UserName;
      }
    } else if (model.ForUserGroupID) {
      const group = this.userGroups.find(p => p.UserGroupId === model.ForUserGroupID);
      if (group) {
        return group.UserGroupName;
      }
    } else {
      return '';
    }

    return '';
  }

  getSubject(model: SystemTaskDataModel) {
    const ids = model.ContentParametersJSON;

    if (!ids) {
      return '';
    }

    let enums: EnumValidValueItemModel[];
    if (model.isSystem) {
      enums = this.systemTaskTypeEnums.filter(p => ids.includes(p.ValidValueItemId));
    } else {
      enums = this.userTaskTypeEnums.filter(p => ids.includes(p.ValidValueItemId));
    }

    if (enums && enums.length > 0) {
      return enums[0].ItemDisplayValue;
    } else {
      return '';
    }
  }

  onShowCompletedChange(event: any) {
    //this.getTasks();
  }

  onShowSystemTasksChange(event: any) {
    //this.getTasks();
  }

  onStartDateFocus(event: FocusEvent) {
    if (!this.queryModel.startDate) {
      this.queryModel.startDate = new Date();
    }
  }

  isPastDue(task: SystemTaskDataModel) {
    const taskDueDate = new Date(task.DueDate);
    return taskDueDate < new Date();
  }

  convertUTCDatetoTimezone(date: Date, tz: string) {
    date = ConversionUtilities.getAdjustedTimezoneDate(date, tz);
    return date;
  }
}
